var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 18C5 19.1046 5.89543 20 7 20H19C20.1046 20 21 19.1046 21 18V10C21 8.89543 20.1046 8 19 8V16C19 17.1046 18.1046 18 17 18H5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6C3 4.89543 3.89543 4 5 4H16C17.1046 4 18 4.89543 18 6V15C18 16.1046 17.1046 17 16 17H5C3.89543 17 3 16.1046 3 15V6ZM11.5 7C11.5 6.72386 11.7239 6.5 12 6.5H16C16.2761 6.5 16.5 6.72386 16.5 7C16.5 7.27614 16.2761 7.5 16 7.5H12C11.7239 7.5 11.5 7.27614 11.5 7ZM12 9.5C11.7239 9.5 11.5 9.72386 11.5 10C11.5 10.2761 11.7239 10.5 12 10.5H16C16.2761 10.5 16.5 10.2761 16.5 10C16.5 9.72386 16.2761 9.5 16 9.5H12ZM11.5 13C11.5 12.7239 11.7239 12.5 12 12.5H16C16.2761 12.5 16.5 12.7239 16.5 13C16.5 13.2761 16.2761 13.5 16 13.5H12C11.7239 13.5 11.5 13.2761 11.5 13ZM7.5 11C8.88071 11 10 9.88071 10 8.5C10 7.11929 8.88071 6 7.5 6C6.11929 6 5 7.11929 5 8.5C5 9.88071 6.11929 11 7.5 11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffers);
export default __webpack_public_path__ + "static/media/offers.20e427ee72a393b36cf2a17126c715e9.svg";
export { ForwardRef as ReactComponent };